/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './acceptConvo.defs'
export { main as default } from './acceptConvo.defs'
